import React, { ReactNode } from 'react';
import GridRow from './GridRow';

interface GridRowNodeProps {
    title: ReactNode;
    node: ReactNode;
}

function GridRowNode({ title, node }: GridRowNodeProps): React.JSX.Element {
    return (
        <GridRow>
            <div className="col-span-12 md:col-span-3">{title}</div>
            <div className="col-span-12 md:col-span-9">{node}</div>
        </GridRow>
    );
}
export default GridRowNode;
